import { TitleBar } from "../components/TitleBar";
import '../assets/Gear.css';

export const GearPage = () => {
    return (
        <>
            <TitleBar title='Silicon Valley Rugby Logo Gear'/>
            <div className='gear-wrapper'>
                <div className='title'>Silicon Valley Rugby Pro Shop by World Rugby Shop</div>
                <p>
                    If you are up for a Silicon Valley Rugby logo t-shirt, polo, jacket, hoodie, ball cap, beanie, bucket
                    hat, training singlet, contact training top, pair of gym shorts, pair of track pants, track jacket,
                    quarter-zip training top, gilet, or match shorts, our partners at World Rugby Shop support us
                    with these items and more, mostly from Canterbury Clothing Company (CCC). Order from our team page at 
                    World Rugby Shop in their checkout, then World Rugby Shop will screen or embroider the items you order, 
                    and ship them directly to you. Items should arrive within a month. WRS rebates 10% of the
                    purchase price to Silicon Valley Rugby.
                </p>
                <p>
                    Shop now for the items below, and many others: 
                    <a href="https://www.worldrugbyshop.com/collections/silicon-valley-high-school-mens-rugby-club">World Rugby Shop</a>
                </p>
                <div className="image-wrapper">
                    <a href="https://www.worldrugbyshop.com/collections/silicon-valley-high-school-mens-rugby-club">
                        <img src="/images/world-rugby-shop.png" alt="world rugby shop" width="500"/>
                    </a>
                </div>
            </div>
        </>
    );
}